class Point2D {
  constructor(x, y) {
    if (typeof x === "object") {
      this.x = x.x ?? 0;
      this.y = x.y ?? 0;
    } else {
      this.x = x ?? 0;
      this.y = y ?? 0;
    }
  }
  copy() {
    return new Point2D(this.x, this.y);
  }
}
export {
  Point2D
};
//# sourceMappingURL=Point2D.js.map
